import styled from 'styled-components'
import { Button } from 'antd'

export const HeaderWrapper = styled.header`
   position: fixed;
   top: 0;
   left: 0;
   right: 0;
   z-index: 1000;
   background: rgba(0, 0, 0, 0.6);
   backdrop-filter: blur(8px);
`

export const HeaderContainer = styled.div`
   max-width: 1400px;
   margin: 0 auto;
   padding: 0 64px;
   height: 72px;
   display: flex;
   align-items: center;
   justify-content: space-between;

   @media (max-width: 1024px) {
      padding: 0 32px;
   }

   @media (max-width: 768px) {
      padding: 0 16px;
   }
`

export const Logo = styled.div`
   font-size: 22px;
   font-weight: 800;
   color: #fff;
   cursor: pointer;
   @media (max-width: 768px) {
      font-size: 18px;
      font-weight: 700;
   }
`

export const MenuWrapper = styled.nav`
   display: flex;
   align-items: center;
   gap: 32px;

   @media (max-width: 768px) {
      display: none;
   }
`

export const MenuItem = styled.a`
   color: #fff;
   font-size: 15px;
   cursor: pointer;
   transition: 0.2s;

   &:hover {
      color: #edbb1d;
   }
`

export const BookButton = styled.div`
   background: transparent;
   border-width:1px;
   border-color: #fff;
   font-weight: 600;
   color: #000

   &:hover {
      background: transparent;
      border-color: #edbb1d;
   }
`

export const MobileMenuButton = styled.div`
   display: none;
   color: #fff;
   font-size: 22px;
   cursor: pointer;

   @media (max-width: 768px) {
      display: block;
   }
`
